const baseURL = (process.env.REACT_APP_BASE_URL || "http://localhost:5000").replace(/\/$/, "");

export default baseURL;
